import { combineReducers } from "redux";

import sidebarMenu from "@/common/reducers/sidebarMenu";
import accounts from "@/modules/Accounts/reducers/accounts";
import contracts from "@/modules/Contracts/reducers/contracts";
import bannersOffers from "@/modules/Offers/reducers/bannersOffers";
import plansOffers from "@/modules/Offers/reducers/plansOffers";
import productsOffers from "@/modules/Offers/reducers/productsOffers";
import tagOffers from "@/modules/Offers/reducers/tagOffers";
import banners from "@/modules/Settings/reducers/banners";
import businessUnits from "@/modules/Settings/reducers/businessUnits";
import carriers from "@/modules/Settings/reducers/carriers";
import distributionCenters from "@/modules/Settings/reducers/distributionCenters";
import inventories from "@/modules/Settings/reducers/inventories";
import lines from "@/modules/Settings/reducers/lines";
import modelsGroups from "@/modules/Settings/reducers/modelsGroups";
import offers from "@/modules/Settings/reducers/offers";
import offersPrices from "@/modules/Settings/reducers/offersPrices";
import organizations from "@/modules/Settings/reducers/organizations";
import permissions from "@/modules/Settings/reducers/permissions";
import plans from "@/modules/Settings/reducers/plans";
import pricingGroups from "@/modules/Settings/reducers/pricingGroups";
import products from "@/modules/Settings/reducers/products";
import productsBrands from "@/modules/Settings/reducers/productsBrands";
import roles from "@/modules/Settings/reducers/roles";
import serviceProviders from "@/modules/Settings/reducers/serviceProviders";
import services from "@/modules/Settings/reducers/services";
import servicesCategories from "@/modules/Settings/reducers/servicesCategories";
import shippingsGroups from "@/modules/Settings/reducers/ShippingsGroups";
import shippingsType from "@/modules/Settings/reducers/ShippingsType";
import users from "@/modules/Settings/reducers/users";
import profile from "@/modules/User/reducers/profile";

const rootReducer = combineReducers({
  accounts,
  businessUnits,
  carriers,
  contracts,
  lines,
  organizations,
  plans,
  profile,
  users,
  shippingsType,
  shippingsGroups,
  modelsGroups,
  distributionCenters,
  products,
  productsBrands,
  inventories,
  offersPrices,
  banners,
  pricingGroups,
  services,
  serviceProviders,
  servicesCategories,
  permissions,
  roles,
  offers,
  productsOffers,
  plansOffers,
  bannersOffers,
  tagOffers,
  sidebarMenu
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
